import { publish } from 'pubsub-js';

import { PUBSUB_TOPICS } from '../../hooks';
import { NotificationType, sendNotification } from '../../utils/toast';
import {
  SEND_EMAIL_REJECTED,
  SEND_EMAIL_REQUESTED,
  SEND_EMAIL_RESOLVED,
} from '../actions/types';
import { defaultState, Status } from '../models/europrisme';

const initialState = { ...defaultState };

export default (state = initialState, action) => {
  switch (action.type) {
    case SEND_EMAIL_REQUESTED: {
      return { ...state, status: Status.LOADING };
    }
    case SEND_EMAIL_RESOLVED: {
      sendNotification({
        title: 'Message envoyé avec succès',
        type: NotificationType.SUCCESS,
      });

      publish(PUBSUB_TOPICS.CONTACT_MESSAGE_SENT_SUCCESS);

      return { ...state, status: Status.IDLE };
    }
    case SEND_EMAIL_REJECTED: {
      sendNotification({
        title: "Erreur lors de l'envoi du message",
        description: 'Veuillez essayer à nouveau',
        type: NotificationType.ERROR,
      });

      return { ...state, status: Status.ERROR };
    }
    default:
      return state;
  }
};
